import { TsDOM as q } from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video'
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { WaitlistForm } from '@/scripts/theme/waitlist-form'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { WelcomePopup } from '@/scripts/theme/welcome-popup'
import { AngelaGptWidget, AngelaGptVideo } from '@/scripts/theme/angela-gpt-widget'
import { ClinicalStudy } from '@/scripts/theme/clinical-study'
import { PressQuoteCarousel } from '@/scripts/theme/press-quote-carousel'
import { BeforeAfter } from '@/scripts/theme/before-after'
import { ScienceAnimation } from '@/scripts/theme/science-animation'
import { CartNotification } from '@/scripts/theme/cart-notification'
import { RoutineScroll } from '@/scripts/theme/routine-scroll'
import { IntroLoader } from '@/scripts/theme/intro-loader'
import { SubscriptionWidget } from '@/scripts/product/subscription'
import '@/scripts/theme/wholesale-register-toggle'
q.safeDefineElement(UcoastVideo)
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(SlideshowComponent)
q.safeDefineElement(StickyHeader)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(ProductSlider)
q.safeDefineElement(MultiProductSlider)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(AngelaGptWidget)
q.safeDefineElement(AngelaGptVideo)
q.safeDefineElement(WelcomePopup)
q.safeDefineElement(WaitlistForm)
q.safeDefineElement(ClinicalStudy)
q.safeDefineElement(PressQuoteCarousel)
q.safeDefineElement(BeforeAfter)
q.safeDefineElement(ScienceAnimation)
q.safeDefineElement(CartNotification)
q.safeDefineElement(RoutineScroll)
q.safeDefineElement(IntroLoader)
q.safeDefineElement(SubscriptionWidget)
